/**
 * String used to separate parts of an MHID.
 */
export var MHID_DELIMITER = '_';
//# sourceMappingURL=MhidDelimiter.js.map